import { render, staticRenderFns } from "./TextAreaAutocomplete.vue?vue&type=template&id=1ba74398"
import script from "./TextAreaAutocomplete.vue?vue&type=script&lang=js"
export * from "./TextAreaAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./TextAreaAutocomplete.vue?vue&type=style&index=0&id=1ba74398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports